export default {  
    BACKEND_URL: "https://api.synup.dev",
    FRONTEND_URL: "https://dev.synup.dev",
}